import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Claim from '../views/Claim.vue'
import Matches from '../views/Matches.vue'
import HomePartner from '../views/HomePartner.vue'
import Login from '../views/Login.vue'
import RateCards from '../views/RateCards.vue'
import {
    MdButton,
    MdContent,
    MdTabs,
    MdIcon,
    MdBottomBar,
    MdField,
    MdRipple,
    MdList,
} from 'vue-material/dist/components'
import 'vue-material/dist/vue-material.min.css'
import '@/styles/theme.scss'
import { Promised } from 'vue-promised'

Vue.use(MdButton)
Vue.use(MdContent)
Vue.use(MdTabs)
Vue.use(MdIcon)
Vue.use(MdBottomBar)
Vue.use(MdField)
Vue.use(MdRipple)
Vue.use(MdList)
Vue.use(VueRouter)
Vue.component('Promised', Promised)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(/* webpackChunkName: "about" */ '../views/About.vue'),
    },
    {
        path: '/reset',
        name: 'Clear',
        component: () =>
            import(/* webpackChunkName: "reset" */ '../views/Clear.vue'),
    },
    {
        path: '/chat',
        name: 'Chat',
        component: () =>
            import(/* webpackChunkName: "chat" */ '../views/Chat.vue'),
        children: [
            {
                path: 'gifs/:category?',
                component: () =>
                    import(
                        /* webpackChunkName: "gif" */ '../components/PickGif.vue'
                    ),
            },
        ],
    },
    {
        path: '/scratchpad',
        name: 'scratchpad',
        component: () =>
            import(
                /* webpackChunkName: "scratchpad" */ '../views/ScratchPad.vue'
            ),
    },
    {
        path: '/pick-gif',
        name: 'pickgif',
        component: () =>
            import(/* webpackChunkName: "gif" */ '../components/PickGif.vue'),
    },
    {
        path: '/rate',
        name: 'Rate',
        component: RateCards,
    },
    {
        path: '/claim',
        name: 'Claim',
        component: Claim,
    },
    {
        path: '/matches',
        name: 'Matches',
        component: Matches,
    },
    {
        path: '/partner/:accessToken',
        name: 'Partner',
        component: HomePartner,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
